export default "__VITE_ASSET__D8D0VLJH__$_?nuxt_component=async&nuxt_component_name=SvgoCommonSepa&nuxt_component_export=default__"